export default __webpack_public_path__ + "static/media/Vector 76 (1).d1094609.svg";